/**
 * Single source of truth for which sidebar sections a user may reach.
 *
 * Used both to filter the sidebar and to guard the matching routes, so a hidden
 * section can no longer be opened by typing its URL. These checks read
 * localStorage (which the user can edit), so they are a UX/navigation guard
 * only — the backend must still reject unauthorised requests.
 */

/** `role_id` of a standard (non-admin) user; admins are role 1. */
const STANDARD_USER_ROLE_ID = "2";

/** User Management is admin-only. */
export const hasUserManagementAccess = (): boolean =>
  localStorage.getItem("role_id") !== STANDARD_USER_ROLE_ID;

/** Social Listening is per-tenant; absent flag means access is allowed. */
export const hasSocialListeningAccess = (): boolean => {
  const storedAccess = localStorage.getItem("social_listening_access");
  return storedAccess === null ? true : storedAccess === "true";
};
